Vue.component('not-loaded', {
  
})